var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["fit-scale.j2"] = require( "fit-scale.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-summary-fit.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.reviews.averageFitRating"]));
frame.set("productAverageFitRating", t_1, true);
if(frame.topLevel) {
context.setVariable("productAverageFitRating", t_1);
}
if(frame.topLevel) {
context.addExport("productAverageFitRating", t_1);
}
var t_2;
t_2 = (lineno = 1, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.bazaarvoice.fit_ratings"]));
frame.set("fitRatingSlugs", t_2, true);
if(frame.topLevel) {
context.setVariable("fitRatingSlugs", t_2);
}
if(frame.topLevel) {
context.addExport("fitRatingSlugs", t_2);
}
if(runtime.contextOrFrameLookup(context, frame, "productAverageFitRating")) {
output += "\n\n    <div class=\"c-product-reviews-summary__section\">";
var t_3;
t_3 = (lineno = 7, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "fitRatingSlugs"),"fitSlide[" + "" + runtime.contextOrFrameLookup(context, frame, "productAverageFitRating") + "" + "]"]));
frame.set("averageRatingSlug", t_3, true);
if(frame.topLevel) {
context.setVariable("averageRatingSlug", t_3);
}
if(frame.topLevel) {
context.addExport("averageRatingSlug", t_3);
}
var t_4;
t_4 = (lineno = 8, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "averageRatingSlug"),runtime.makeKeywordArgs({"orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("localizedAverageRating", t_4, true);
if(frame.topLevel) {
context.setVariable("localizedAverageRating", t_4);
}
if(frame.topLevel) {
context.addExport("localizedAverageRating", t_4);
}
if(runtime.contextOrFrameLookup(context, frame, "localizedAverageRating")) {
output += "\n\n            <p class=\"c-product-reviews-summary__heading\">\n                ";
output += runtime.suppressValue((lineno = 13, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_overall-fit-label",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "localizedAverageRating")]})])), env.opts.autoescape);
output += "\n            </p>\n\n        ";
;
}
output += "\n\n        <div class=\"c-product-reviews-summary__icon\">\n\n            ";
env.getTemplate("fit-scale.j2", false, "product/templates/product-reviews-summary-fit.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n        </div>\n\n    </div>\n\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-summary-fit.j2"] , dependencies)